/*** IMPORTS FROM imports-loader ***/
var define = false;

export const VERSION = "1.6.2";
